export const toMissingData = data => {
  return data.reduce((result, item) => {
    const diff = item.hoursPerWeek - item.loggedHours
    if (result['missingHours']) {
      result['missingHours'] = result['missingHours'] + diff
    } else {
      result['missingHours'] = diff
    }

    if (result.data) {
      result.data.push(item)
    } else {
      result.data = [item]
    }

    return result
  }, {})
}
